import { z } from "zod";
import { ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS, ALPHANUMERIC_REGEX_WITH_ACCENTS } from "../template/create";

const stripHtml = (value: string) => {
    let result = "";
    let insideTag = false;

    for (const char of value) {
        if (char === "<") {
            insideTag = true;
            result += " ";
            continue;
        }

        if (char === ">") {
            insideTag = false;
            continue;
        }

        if (!insideTag) {
            result += char;
        }
    }

    return result.split("&nbsp;").join(" ").trim();
};

export const createLegalSchema = z.object({
    name: z.string().min(1, { message: "Debes ingresar un nombre" }).regex(ALPHANUMERIC_REGEX_WITH_ACCENTS, { message: ALPHANUMERIC_ERROR_MESSAGE_WITH_ACCENTS }),
    legal_text: z.string().refine((value) => stripHtml(value).length > 0, { message: "Debes ingresar un texto legal" }),
    color: z.string().min(1, { message: "Debes seleccionar un color" }),
});

export type CreateLegalFields = z.infer<typeof createLegalSchema>;
